<template>
  <div class="menu">
    <div class="statusBar" >
      <br>
      <div style="position: fixed; width: 100vw; height: 40px; margin-top: -5px;">
        訂單列表
      </div>
      <cube-tab-bar v-model="selectedLabelDefault" show-slider style="width:100%;  height: 45px;">
        <cube-tab v-for="item in tabs" :icon="item.icon" :label="item.label" :key="item.label">
        </cube-tab>
      </cube-tab-bar>
    </div>
    <div class="container" id="container">
      <div class="dia" v-if="orderRecord.length === 0">
        <div style="transform: scale(4); width: 50px; height: 20px;margin: 35px auto; margin-top: 60px; color: var(--main-color);">
          <i class="cubeic-warn"></i><br><br>
        </div>
        <span style="color: var(--main-color); opacity: 0.8;">目前無記錄，請至門市進行消費。</span>
      </div>
    </div>

    <!-- <div class="blog-post">
      <ul class="list" >
        <div class="item">
          <div class="left">
            <li class="title">店家:{{store.filter(el => el.id === data.storeId)[0].name}}</li>
          </div>
          <div class="middle">
            <li class="title">日期:{{data.date}}</li>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <li class="entitle">訂單編號 {{data.orderId}}</li>
          </div>
          <div class="middle">
            <li class="entitle">消費金額 {{data.amount}}</li>
            <li class="entitle">獲得點數 {{data.getPoint}}</li>
          </div>
        </div>
      </ul>
    </div> -->

    <div class="loading">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
    </div>

    <div class="loadMore" v-if="load === true" @click="loadMoreInfo()" :style="{ opacity: allowCall === true ? 1 : 0}" >
      <i class="cubeic-select" style=""></i>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapMutations, mapGetters, mapActions } from 'vuex'
import counter from '@/components/data/counter.json'
import QrcodeVue from 'qrcode.vue';
const container = document.getElementById('container');
const loading = document.querySelector('.loading');
const store = [ {
          name: '微風南山店',
          id: '22001'
        },
        {
          name: '板橋大遠百店',
          id: '22003'
        },
        {
          name: '桃園華泰店',
          id: '23001'
        },
        {
          name: '三井台中港店',
          id: '24001'
        },
        {
          name: '台中大遠百店',
          id: '24002'
        },
        {
          name: '林口三井店',
          id: '22002'
        },
        {
          name: '台茂購物中心',
          id: '23002'
        },
        {
          name: '新竹巨城店',
          id: '50009'
        },
      ]
export default {
  data () {
    return {
      storeList: [],
      load: false,
      allowCall: true,
      date: '',
      index: 0,
      thisYear: '',
      selectedLabelDefault: '已完成',
      tabs: [{
        label: '已完成',
        C_record: [],
        // icon: 'cubeic-home'
      },
      // {
      //   label: '進行中',
      //   record: [],
      //   // icon: 'cubeic-home'
      // }
      ],
    }
  },
  props: ['phone','eid', 'orderRecord', 'saleroom'],
  mounted() {
    var date = new Date();
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString();
    var day = date.getDate() < 10 ? `0${date.getDate().toString()}` : date.getDate().toString();
    this.thisYear = year
    if (this.counterList.length === 0) {
      this.getStoreList({clientId: this.info.clientId})
      .then((res) => {
        this.storeCounter = res.data.result.filter(el => el.no !== '無')
      })
    }
    // console.log(this.orderRecord);
    // console.log(this.tempRecord);
    // console.log(this.updateRec);
    // console.log(this.tempIndex);
    if (this.tempRecord.length !== 0) {
      if (this.tempIndex !== 0) {
        this.index = this.tempIndex
      }
      const data = this.tempRecord
      this.allowCall = false
      this.addDataToDOMArr(data)
      // console.log(data);
      // console.log('goTemp');
    } else {
      // console.log('1');
      if (this.orderRecord.length !== 0) {
        this.allowCall = false
        const loading = document.querySelector('.loading');
        loading.classList.add('show');
        this.Record()
      }
    }

    // const date = this.orderRecord.reverse()[this.index + 1]
    const vm = this;
    window.addEventListener('scroll', () => {
      var windowH = document.documentElement.clientHeight;
      var documentH = document.documentElement.offsetHeight;
      var scrollH = document.body.scrollTop || document.documentElement.scrollTop;
      if ((windowH + scrollH > documentH) && vm.allowCall) {
        if (this.index < this.orderRecord.length ) {
          vm.allowCall = false
          this.load = false;
          vm.showLoading();
        } else if (this.index < this.tempRecord.length) {
          vm.allowCall = false
          this.load = false;
          vm.showLoading();
        }
      }
    });
  },
  computed: {
    ...mapGetters({
      tempRecord: 'tempRecord',
      tempIndex: 'tempIndex',
      info: 'info',
      counterList: 'counterList'
    }),
    storeCounter: {
      get () { return this.counterList },
      set(value) { this.updateList({ list: value }); },
    },
    updateRec: {
      get () { return this.tempRecord },
      set(value) { this.updateRecord({ record: value }); },
    },
    updateInd: {
      get () { return this.tempIndex },
      set(value) { this.updateIndex({ index: value }); },
    },

  },
  watch: {
    tempRecord(val) {
      // console.log(val);
    },
    index(val) {
      // console.log(val);
      if (val !== this.orderRecord.length) {
        this.load = true;
        // console.log(true);
      } else if (val === this.orderRecord.length){
        // console.log(false);
        this.load = false;
      }
    }
  },
  methods: {
    ...mapActions({
      getRecord: 'getRecord',
      getStoreList: 'getStoreList'
    }),
    ...mapMutations({
      updateRecord: 'updateRecord',
      updateIndex: 'updateIndex',
      updateList: 'updateList'
    }),
    loadMoreInfo() {
      if (this.allowCall) {
        this.allowCall = false
        this.showLoading();
      }
      // setTimeout(() => {
      //   this.showLoading();
      // },1000)
    },
    Record() {
      // console.log(this.orderRecord);
      // console.log(this.orderRecord[this.index]);
      this.getRecord({ clientId: this.info.clientId, phone: this.phone, begin: this.orderRecord[this.index].toString(), end: this.orderRecord[this.index].toString(), storeId: ''})
      .then((res) => {
        // console.log(res);
        // console.log(this.thisYear);
        // console.log(res.data.result[0].date.substr(0,4));

        // console.log(res.data.result.filter(el => el.date.substr(0,4) === this.thisYear));
        this.addDataToDOM(res.data.result.filter(el => el.date.substr(0,4) === this.thisYear).reverse());
        this.index = this.index + 1;
        this.updateInd = this.index
        this.updateRec.push(res.data.result.filter(el => el.date.substr(0,4) === this.thisYear));
        // console.log(this.updateRec);
        setTimeout(() => {
          // this.addDataToDOM(res.data.result[0]);
          // this.index = this.index += 1;
          this.allowCall = true;
        },1000)
        // console.log(this.index);
        // console.log(this.orderRecord.length - 1);
      })
    },
    showLoading() {
      const loading = document.querySelector('.loading');
      loading.classList.add('show');
      // load more data
      setTimeout(this.Record(), 1000)
    },
    // async Record() {
    //   console.log(this.orderRecord[this.index]);
    //   try {
    //     const res = await this.getRecord({ clientId: "1551915772", phone: this.phone, begin: this.orderRecord[this.index].toString(), end: this.orderRecord[this.index].toString(), storeId: '22001'})
    //     .then((res) => {
    //       this.addDataToDOM(res.data.result[0]);
    //       this.index = this.index + 1;
    //       setTimeout(() => {
    //         // this.addDataToDOM(res.data.result[0]);
    //         // this.index = this.index += 1;
    //         this.allowCall = true;
    //       },1500)
    //     });
    //   } catch(err) {
    //     console.log('error: ', err)
    //   }
    // },

    getRandomNr() {
      this.index = this.index + 1
    },

    addDataToDOM(data) {
      // console.log(data);
      // console.log(localStorage.getItem('brand'));
      // console.log(this.saleroom);
      // console.log(this.counterList.filter(el => el.no === this.saleroom));
      // console.log(this.counterList);
      // console.log(this.saleroom);
      // return;
      // console.log(this.counterList.filter(el => el.name === localStorage.getItem('brand')));
      const container = document.getElementById('container');
      const loading = document.querySelector('.loading');
      // console.log(data);
      // console.log(counter);
      // console.log(localStorage.getItem('brand'));
      // console.log(counter.filter(el => el.counter === localStorage.getItem('brand'))[0].items.filter(el => el.id === data[i].storeId)[0].name);
      // return;
      for (let i = 0; i< data.length ;i++) {
      const postElement = document.createElement('div');
      postElement.classList.add('blog-post');
      postElement.innerHTML = `
        <ul class="list">
          <div class="item">
            <div class="left">
              <li class="title">店家:${this.counterList.filter(el => el.no === data[i].storeId)[0] ? this.counterList.filter(el => el.no === data[i].storeId)[0].name : data[i].storeId}</li>
            </div>
            <div class="middle">
              <li class="title">日期:${data[i].date}</li>
            </div>
          </div>
          <div class="item">
            <div class="left">
              <li class="entitle">訂單編號${data[i].orderId}</li>
            </div>
            <div class="middle">
              <li class="entitle">消費金額 ${data[i].amount}</li>
              <li class="entitle">獲得點數 ${data[i].getPoint}</li>
            </div>
          </div>
        </ul>
      `;
      // console.log(postElement);
      container.appendChild(postElement);
      // console.log(container);
      }
      loading.classList.remove('show');
    },

    addDataToDOMArr(data) {
      const container = document.getElementById('container');
      const loading = document.querySelector('.loading');
      // console.log(data);
      // console.log(this.counterList);
      for (let i = 0; i< data.length ;i++) {
        for (let e = 0;  e < data[i].length ;e++) {
          // console.log(this.counterList.filter(el => el.no === data[i][e].storeId));
          const postElement = document.createElement('div');
          postElement.classList.add('blog-post');
          postElement.innerHTML = `
            <ul class="list">
              <div class="item">
                <div class="left">
                  <li class="title">店家:${this.counterList.filter(el => el.no === data[i][e].storeId)[0] ? this.counterList.filter(el => el.no === data[i][e].storeId)[0].name : data[i][e].storeId}</li>
                </div>
                <div class="middle">
                  <li class="title">日期:${data[i][e].date}</li>
                </div>
              </div>
              <div class="item">
                <div class="left">
                  <li class="entitle">訂單編號${data[i][e].orderId}</li>
                </div>
                <div class="middle">
                  <li class="entitle">消費金額 ${data[i][e].amount}</li>
                  <li class="entitle">獲得點數 ${data[i][e].getPoint}</li>
                </div>
              </div>
            </ul>
          `;
          container.appendChild(postElement);
          loading.classList.remove('show');
          this.allowCall = true;
        }
      }
    },
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,600&display=swap');

  body {
    font: 300 14px/18px Roboto;
    padding-bottom: 100px;
  }

  .menu {
    z-index: 0;
    padding-left: 0!important;
    padding-right: 0!important;
    margin: 0 auto;
    overflow: hidden;
    width: 100%;
    height: 612px;
    max-width: 540px;
    // height: 650px;
    background-color: #ffffff;
    /* border: 1px solid rgb(170, 170, 170); */
    /* border:1px solid #8a8a8a; */
  }
  .dia {
    font-size: 16px;
    padding: 10px;
    width: 75%;
    max-width: 300px;
    height: 180px;
    border-radius: 10px;
    border: 1px solid var(--main-color);
    margin: 50px auto;
  }
  .loadMore {
    // transform:translateX(15%);
    // display: flex;
    // align-items: center; // 置中
    // justify-content: center; // 置中
    z-index: 10000000;
    top:85%;
    left:53.5%;
    line-height: 28px;
    margin-left:-27px;
    margin-top: -23px;
    // height: 25px;
    // width: 25px;
    position: fixed;
    // background-color: var(--main-color);
    // transform: scale(2);
    color: white;
    transform: scale(1.5);
    display: inline-block;
    width: 30px;
    height: 30px;
    padding: 0px;
    box-sizing:content-box;
    border-radius: 50%;
    background-color: var(--main-color);
    // border-radius: 50%;
    -webkit-animation-name: myframes1;
            animation-name: myframes1;
    -webkit-animation-duration: 300ms;
            animation-duration: 300ms;
    -webkit-animation-timing-function: ease-in-out;
            animation-timing-function: ease-in-out;
  }
  .loading {
    z-index: 100;
    display: flex; // 置中
    align-items: center; // 置中
    justify-content: center; // 置中
    margin: 0 auto;
    position: fixed;
    left: 0!important;
    right: 0!important;
    top: 10%;
    color: #111111;
    -webkit-animation-name: myframes;
            animation-name: myframes;
    -webkit-animation-duration: 500ms;
            animation-duration: 500ms;
    -webkit-animation-timing-function: ease-in-out;
            animation-timing-function: ease-in-out;
    border-radius: 5px;
  }
  .top {
    width: 100vw;
    height: 45px ;
    background-color: #ffffffff;
  }
  .top .list{
    text-align: left;
    height: 400px;
    width: 103vw;
  }
  .top  .list .item{
    margin-top: 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    border-bottom: 2px solid rgba(210, 210, 210, 0.815);
    height: 40px;
    padding: 5px;
  }
  .statusBar {
    // border-bottom: 1px solid var(--main-color);
    z-index: 1000;
    position: fixed;
    font-size: 17px;
    width: 100vw;
    height: 60px ;
    background-color: #ffffffff;
  }

  .container {
    // height: 900px;
    width: 90%;
    min-width: 350px;
    color: black;
    height: calc(100% - 250px);
    margin: 0 auto;
    margin-top: 80px;
    max-width: 600px;
    overflow: auto;
    overflow-y: auto;
    -ms-overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 100px;
  }

  .container .blog-post {
    background-color: #fff;
    box-shadow: 5px 1px 2px rgba(50, 50, 50, .1), 5px 1px 6px 1px rgba(50, 50, 50, .1),
    0px 2px 3px rgba(60, 60, 60, 0.1);
    border-radius: 4px;
    height: 100px;
    padding: 25px;
    margin: 20px 0;
  }
  .container .blog-post .list{
    margin-left: -15px;
    text-align: center;
    height: 100%;
    max-height: 350px;
    width: 85vw;
  }
  .container .blog-post .list .item{
    margin-left: -10px;
    margin-top: -25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-content: space-between;
    height: 40px;
    padding: 20px;
    width: 95%;
  }
  .container .blog-post  .list .item .title{
    margin-top: 0px;
    color: rgba(33, 33, 33, 0.851);
    font-size: 19px;
    letter-spacing: 0.3px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }
  .container .blog-post .list .item .middle{
    font-size: 13px;
  }
  .entitle{
    text-align: left;
    font-size: 12px;
    color: #21797b;
    margin-top: 0px;
    margin-top: 3px;
  }

  .loading {
    opacity: 0;
    display: flex;
    position: fixed;
    bottom: 50px;
    left: 0%;
    transform: translateX(0%);
    transition: opacity .3s ease-in;
  }

  .loading.show {
    opacity: 1;
  }

  .ball {
    background-color: #777;
    border-radius: 50%;
    margin: 5px;
    height: 10px;
    width: 10px;
    animation: jump .5s ease-in infinite;
  }

  .ball:nth-of-type(2) {
    animation-delay: 0.1s;
  }

  .ball:nth-of-type(3) {
    animation-delay: 0.2s;
  }
  @keyframes myframes1 {
    0% {
      -webkit-transform: scale(0) translateY(200px) rotate(0deg);
            transform: scale(0) translateY(200px) rotate(0deg);
    }
    50% {
      -webkit-transform: scale(0.5) rotate(0deg);
              transform: scale(0.5) rotate(0deg);
    }
    80% {
      -webkit-transform: scale(0.8) rotate(0deg);
              transform: scale(0.8) rotate(0deg);
    }
    100% {
    -webkit-transform: scale(1) translateY(0px) rotate(0deg);
      transform: scale(1) translateY(0px) rotate(0deg);
    }
  }
  @keyframes jump {
    0%, 100% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-10px);
    }
  }
</style>

